import { IkasCustomerAddress } from "./address";
import { IkasCustomerAttributeValue } from "./attribute/value";
import { IkasBaseModel } from "../base";

export type IkasCustomer = {
  accountStatusUpdatedAt: number | null;
  customerGroupIds: string[] | null;
  customerSequence: number | null;
  email: string | null;
  emailVerifiedDate: number | null;
  firstName: string;
  fullName: string | null;
  isEmailVerified: boolean | null;
  isPhoneVerified: boolean | null;
  lastName: string | null;
  note: string | null;
  orderCount: number | null;
  passwordUpdateDate: number | null;
  phone: string | null;
  phoneVerifiedDate: number | null;
  subscriptionStatusUpdatedAt: number | null;
  tagIds: string[] | null;

  registrationSource: IkasCustomerRegistrationSource | null;
  accountStatus: IkasCustomerAccountStatus | null;
  addresses: IkasCustomerAddress[] | null;
  subscriptionStatus: IkasCustomerEmailSubscriptionStatus | null;
  attributes: IkasCustomerAttributeValue[] | null;
} & IkasBaseModel;

export enum IkasCustomerAccountStatus {
  ACTIVE_ACCOUNT = "ACTIVE_ACCOUNT",
  DECLINED_ACCOUNT_INVITATION = "DECLINED_ACCOUNT_INVITATION",
  DISABLED_ACCOUNT = "DISABLED_ACCOUNT",
  INVITED_TO_CREATE_ACCOUNT = "INVITED_TO_CREATE_ACCOUNT",
}

export enum IkasCustomerRegistrationSource {
  credentials = "credentials",
  facebook = "facebook",
  google = "google",
}

export enum IkasCustomerEmailSubscriptionStatus {
  NOT_SUBSCRIBED = "NOT_SUBSCRIBED",
  PENDING_CONFIRMATION = "PENDING_CONFIRMATION",
  SUBSCRIBED = "SUBSCRIBED",
}
